
export default class MemberProfileResponseModel {
    public givenName: string = '';
    public surname: string = '';
    public emailAddress: string = '';
    public createdDateTimeUtc?: Date;
    public currentSignInDateTimeUtc?: Date;
    public lastSignInDateTimeUtc?: Date;
    public lastPrimaryPasswordChangeDateTimeUtc?: Date;
    public lastBackupPasswordChangeDateTimeUtc?: Date;
}
